var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail-container',{attrs:{"has-header":false,"pageTitle":"대출 상세","is-page-loaded":_vm.isLoadedData}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})])}
var staticRenderFns = []

export { render, staticRenderFns }